import { render, staticRenderFns } from "./documentAdministrator.vue?vue&type=template&id=2023c94c"
import script from "./documentAdministrator.vue?vue&type=script&lang=js"
export * from "./documentAdministrator.vue?vue&type=script&lang=js"
import style0 from "./documentAdministrator.vue?vue&type=style&index=0&id=2023c94c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports